export enum MessagingSource {
  PPP = 'ppp',
  PPC = 'ppc',
  BULK_MESSAGING = 'bulk-messaging',
}
